var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalkthroughLegacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.55933,
    y: 1.91309,
    width: 32,
    height: 32,
    stroke: "#151515",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5727 9.57975H10.8927C9.97219 9.57975 9.22599 10.3259 9.22599 11.2464V24.5798C9.22599 25.5002 9.97218 26.2464 10.8927 26.2464H13.5727V9.57975ZM10.8927 7.91309C9.05171 7.91309 7.55933 9.40547 7.55933 11.2464V24.5798C7.55933 26.4207 9.05171 27.9131 10.8927 27.9131H15.2393V7.91309H10.8927Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8126 9.57975H15.466V26.2464H19.8126V9.57975ZM13.7993 7.91309V27.9131H21.4793V7.91309H13.7993Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.226 9.57975H21.546V26.2464H24.226C25.1465 26.2464 25.8927 25.5002 25.8927 24.5798V11.2464C25.8927 10.3259 25.1465 9.57975 24.226 9.57975ZM19.8793 7.91309V27.9131H24.226C26.0669 27.9131 27.5593 26.4207 27.5593 24.5798V11.2464C27.5593 9.40547 26.0669 7.91309 24.226 7.91309H19.8793Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkthroughLegacy);
export default __webpack_public_path__ + "static/media/walkthrough-legacy.eba96b4e416235cdcc92d7b7144e8a3f.svg";
export { ForwardRef as ReactComponent };